import { Stack } from "@chakra-ui/react";

const Dash = () => {
	return (
		<Stack w="100%" h="100%">
			<iframe
				src="https://heroku-deploy-streamlit.herokuapp.com?name=lyly"
				title="teste"
				allowfullscreen={true}
				height="682"
			></iframe>
		</Stack>
	);
};
export default Dash;
